module.exports = __webpack_public_path__ + "img/win_item15.9f07ddfa.png";